import React, { Fragment, useEffect, useRef, useState } from "react";
import useSize from "../../../Utils/useSize/useSize";
import Filter from "./Filter/Filter";
import moment from "moment";
import Menu from "./Menu";

import Backend from "../../../Backend/Backend";
import toast from "react-hot-toast";

import { toJpeg } from "html-to-image";

import Null from "./Type/Loss/Null";

import MasterLoss from "./Type/Loss/Master";
import BrokerLoss from "./Type/Loss/Broker";
import TotalLoss from "./Type/Loss/Total";

import MasterProfit from "./Type/Profit/Master";
import BrokerProfit from "./Type/Profit/Broker";
import TotalProfit from "./Type/Profit/Total";

const backend = await new Backend().init();

export default function Settlement(props) {
  const windowSize = useSize();

  const elementRef = useRef(null);

  const user_id = props.user_id;

  const [user, setUser] = useState("");

  const [loading, setLoading] = useState(false);

  const [profitloss, setProfitLoss] = useState(0);
  const [commission, setCommission] = useState(0);

  const [master_commission, setMasterCommission] = useState(0);
  const [master_booked, setMasterBooked] = useState(0);
  const [master_total, setMasterTotal] = useState(0);
  const [master_sharing, setMasterSharing] = useState(0);

  const [broker_commission, setBrokerCommission] = useState(0);
  const [broker_booked, setBrokerBooked] = useState(0);
  const [broker_total, setBrokerTotal] = useState(0);
  const [broker_sharing, setBrokerSharing] = useState(0);

  const [date_start, setDate_Start] = useState(moment().startOf("week"));
  const [date_end, setDate_End] = useState(moment().endOf("week"));

  useEffect(() => {
    loadUser();
    loadSettlement(moment().startOf("week"), moment().endOf("week"));
  }, []);

  const loadSettlement = (a, b) => {
    setDate_Start(a);
    setDate_End(b);

    setLoading(true);
    let data = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),

      start: a == undefined ? date_start : a,
      end: b == undefined ? date_end : b,
      user_id: user_id,
    };

    backend.settlement_master(data).then((r) => {
      setLoading(false);
      if (r.error == "False") {
        setProfitLoss(r.booked);
        setCommission(r.commission);

        setMasterCommission(r.master_commission);
        setMasterBooked(r.master_booked);
        setMasterTotal(r.master_total);
        setMasterSharing(r.mastersharing);

        setBrokerCommission(r.broker_commission);
        setBrokerBooked(r.broker_booked);
        setBrokerTotal(r.broker_total);
        setBrokerSharing(r.brokersharing);
      } else {
        if (r.logout == 1) {
          window.LogOut();
        } else {
          toast.error(r.message);
        }
      }
    });
  };

  const loadUser = () => {
    setLoading(true);
    let data = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),
      user_id: user_id,
    };
    backend.load_user_select(data).then((r) => {
      setLoading(false);
      if (r.error == "False") {
        setUser(r.user);
      } else {
        toast.error(r.message);
      }
    });
  };

  const htmlToImageConvert = () => {
    toJpeg(elementRef.current, { cacheBust: false })
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.download = `${user.username}-SETTLEMENT.jpeg`;
        link.href = dataUrl;
        link.click();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div
      style={{
        width: windowSize[0] - 100,
        height: windowSize[1] - 170,
      }}
    >
      <Filter
        settlement={loadSettlement}
        htmlToImageConvert={htmlToImageConvert}
      />
      <div
        ref={elementRef}
        style={{
          height: windowSize[1] - 250,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          paddingTop: 20,
          textTransform: "uppercase",
        }}
      >
        <div
          className="primary"
          style={{
            height: 55,
            width: 450,
            borderRadius: 10,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div className="large white"> USER : {user.username}</div>
          <div style={{ display: "flex", width: "100%" }}>
            <div
              className="large white"
              style={{
                flex: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              START : {moment(date_start).format("DD-MM-YYYY")}
            </div>
            <div
              className="large white"
              style={{
                flex: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              END : {moment(date_end).format("DD-MM-YYYY")}
            </div>
          </div>
        </div>

        <div
          className="buy"
          style={{
            marginTop: 10,
            height: 30,
            width: 450,
            borderRadius: 10,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div className="large white"> PROFIT</div>
        </div>

        <Menu />

        {profitloss == null ? (
          <Null />
        ) : profitloss > 0 ? null : (
          <Fragment>
            <MasterProfit
              commission={master_commission}
              profitloss={master_booked}
              total={master_total}
              master_sharing={master_sharing}
            />
            <BrokerProfit
              commission={broker_commission}
              profitloss={broker_booked}
              total={broker_total}
              broker_sharing={broker_sharing}
            />
            <TotalProfit
              commission={commission}
              profitloss={profitloss}
              total={profitloss}
            />
          </Fragment>
        )}

        <div
          className="sell"
          style={{
            marginTop: 10,
            height: 30,
            width: 450,
            borderRadius: 10,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div className="large white"> LOSS </div>
        </div>

        <Menu />

        {profitloss == null ? (
          <Null />
        ) : profitloss < 0 ? null : (
          <Fragment>
            <MasterLoss
              commission={master_commission}
              profitloss={master_booked}
              total={master_total}
              master_sharing={master_sharing}
            />
            <BrokerLoss
              commission={broker_commission}
              profitloss={broker_booked}
              total={broker_total}
              broker_sharing={broker_sharing}
            />
            <TotalLoss
              commission={commission}
              profitloss={profitloss}
              total={profitloss}
            />
          </Fragment>
        )}
      </div>
    </div>
  );
}
